import { createApi, BaseQueryFn } from '@reduxjs/toolkit/query/react';
import Query from '@arcgis/core/rest/support/Query';
import * as query from '@arcgis/core/rest/query';

export interface Params {
  url: string;
  queryParams: __esri.QueryProperties;
}

const returnAttributes = (data: __esri.FeatureSet) => {
  if (!data.features.length) {
    return [];
  }

  const dataJSON = data.toJSON();
  return dataJSON;
};

/**
 * @param {string} baseUrl - base url for the api
 * @param {Params} params - Param object with required values
 * @param {string} params.url - url to query
 * @param {__esri.QueryProperties} params.queryParams - Query params
 * @returns data object is request is successful or error if request fails
 */
const esriBaseQuery = (): BaseQueryFn => {
  return async (params: Params) => {
    const { url, queryParams } = params;

    const queryObject = new Query({
      ...queryParams,
    }) as __esri.Query;

    try {
      const queryResult = (await query.executeQueryJSON(url, queryObject)) as __esri.FeatureSet;
      // @return data Object, this is required is request is sucsess
      return {
        data: returnAttributes(queryResult),
      };
    } catch (error: any) {
      console.error('error: ', error);
      // @return error Object, this is required
      return {
        error: {
          status: error?.response?.status,
          data: error,
        },
      };
    }
  };
};

export const api = createApi({
  reducerPath: 'api',
  baseQuery: esriBaseQuery(),
  endpoints: (build) => {
    return {
      // export getEsriRestServiceData method
      getEsriRestServiceData: build.query({ query: (params: Params) => params }),
    };
  },
});

// Redux will generate a hook for you
export const { useGetEsriRestServiceDataQuery } = api;
